import { ReactComponent as ExpandIcon } from 'components/icons/down.svg';
import React from 'react';
import styled from 'styled-components';
import {
  black,
  borderColorNotes,
  darkgrey,
  gradientGreenDark,
  gradientGreenLight,
  grey,
  highlightGradientBlueDark,
  highlightGradientBlueLight,
  white,
} from 'styles/Colors';

export const Span = styled.span`
  display: block;
  position: relative;
`;

export const NotSaved = styled.div`
  padding: 1rem;
  position: relative;
  padding: 1px;
  border: 1px solid red;
  border-radius: 6px;
  overflow: hidden;
  height: 65px;
  margin-bottom: 5px;
`;

export const Player = styled(Span)`
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: Lato;
  font-size: 13px;
  line-height: 1.23;
  letter-spacing: 0.5px;
  color: ${black};
  opacity: 0.37;
`;

export const Type = styled(Span)`
  font-family: Lato;
  font-size: 13px;
  line-height: 1.23;
  letter-spacing: 0.5px;
  color: ${black};
  opacity: 0.37;
`;

export const TooltipText = styled(Span)`
  font-family: Lato;
  font-size: 12px;
  visibility: hidden;
  width: 90px;
  background-image: linear-gradient(92deg, #414141, rgba(65, 65, 65, 0.82));
  color: ${white};
  text-align: center;
  border-radius: 5px;
  padding: 2spx;
  position: absolute;
  z-index: 1;
  right: 15px;
  top: 6px;
`;

export const Warning = styled(Span)`
  top: -8px;
  position: relative;
  margin-left: auto;
  &:hover ${TooltipText} {
    visibility: visible;
  }
`;

export const FirstRow = styled.div`
  display: flex;
  height: 15px;
`;

export const PlaySequenceNumber = styled(Span)`
  margin-left: auto;
  color: ${grey};
  position: relative;
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const WarmupOption = styled.div`
  line-height: 35px;
  font-family: Lato;
  font-size: 15px;
  color: ${darkgrey};
  border-top: 1px solid ${borderColorNotes};
  position: relative;
  white-space: nowrap;
`;

export const Score = styled(Span)`
  font-family: Oswald;
  font-size: 22px;
  font-weight: 500;
  line-height: 1.09;
  letter-spacing: 0.5px;
  color: ${black};
`;

export const StyledExpandIcon = styled((props) => <ExpandIcon {...props} />)`
  position: absolute;
  z-index: 5;
  top: 30px;
  right: 0;
  &.opened {
    transform: rotate(180deg);
  }
`;

export const PlayWrapper = styled.div`
  overflow: hidden;
  position: relative;
  border-radius: 5px;
  cursor: pointer;
  padding: 5px;
  display: block;
  background: ${white};
  margin-bottom: 5px;
  &.even {
    background-image: linear-gradient(103deg, #f1f1f1, #f9f9f9);
  }

  &:last-of-type {
    margin-bottom: 0px;
  }
  &.selected {
    background-image: linear-gradient(278deg, ${highlightGradientBlueLight}, ${highlightGradientBlueDark});
    ${Player},
    ${Type},
    ${Score} {
      color: ${white};
      opacity: 1;
    }
    ${FirstRow} {
      ${PlaySequenceNumber} {
        color: ${white};
      }
    }
    ${WarmupOption} {
      color: ${white};
      border-color: ${white};
    }
  }

  &.animate {
    &::before {
      content: '';
      opacity: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
      background: linear-gradient(291.3deg, ${gradientGreenLight} 0%, ${gradientGreenDark} 99.45%);
      animation: fadeOutAnimation 2s 1 cubic-bezier(1, 0.1, 0.6, 0);
      z-index: 0;
    }
    opacity: 1;

    @keyframes fadeOutAnimation {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  }
`;
